import { SignalDirection } from '@cadstrom/sigma-engine-shared';

export const signalDirectionLabels: Record<SignalDirection, string> = {
	[SignalDirection.BiDirectionalIO]: 'Bidirectional I/O',
	[SignalDirection.Input]: 'Input',
	[SignalDirection.Output]: 'Output',
};
